<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2020-11-16 15:50:28
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/product/detail/components/SkuList/index.vue
-->
<template>
  <div class="sku_con">
    <div
      v-for="(item, index) in mallretailspu.relationSpus"
      :key="index"
      class="sku_list"
      :class="{
        sku_list_bg: skuIndex === index,
        bor_left: index !== 0 && skuIndex !== index
      }"
      @click="switchSku(index, item.spuId)"
    >
      <div class="item_width">
        <div class="font12 font_weight400 colo055 list_item">
          <span class="item_item">{{ item.name }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      skuIndex: 0
    };
  },
  computed: {
    mallretailspu() {
      return this.$store.getters.mallretailspu;
    }
  },
  mounted() {
    this.mallretailspu.relationSpus.forEach((item, index) => {
      if (item.spuId === parseInt(this.$route.query.id)) {
        this.skuIndex = index;
        return;
      }
    });
  },
  methods: {
    switchSku(index, spuId) {
      this.skuIndex = index;
      this.$emit("switchSku", index, spuId);
    }
  }
};
</script>
<style lang="less" scoped>
.sku_con {
  display: flex;
  overflow-y: hidden;
  flex-wrap: nowrap;
  .sku_list_bg {
    background: #fff;
    box-shadow: 0px 0px 7px 6px rgba(193, 200, 207, 0.2);
    border-radius: 6px 6px 0px 0px;
    font-weight: 600 !important;
    color: #bf9264 !important;
    border-left: none !important;
    padding: 9px 8px !important;
    margin: 0 !important;
  }
  .bor_left {
    border-left: 1px solid rgba(0, 0, 0, 0.2);
  }
  .sku_list {
    // padding: 0 8px;
    margin: 9px 0;
    .item_width {
      width: 120px;
    }
    .item_item {
      line-height: 16px;
    }
  }
}
</style>
